import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./components/main/App.jsx";
import "bootstrap/dist/css/bootstrap.min.css";
import "jquery/dist/jquery.min.js";
import "bootstrap/dist/js/bootstrap.min.js";

import "./main.css";

import ErrorHandler from "./components/main/ErrorHandler.jsx";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { backfillHasStartTime } from "./services/script/backfillHasStartTime";

if (import.meta.env.VITE_NODE_ENV !== "production") {
  // One-off backfill for details.hasStartTime. Run from the browser console:
  //   await window.backfillHasStartTime()                // dry run
  //   await window.backfillHasStartTime({ apply: true }) // write
  window.backfillHasStartTime = backfillHasStartTime;
}

const queryClient = new QueryClient();

function startApp() {
  const app = (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
      <ErrorHandler />
    </QueryClientProvider>
  );

  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(app);
}

// initFacebookSdk().then(() => startApp());
startApp();
